import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { OptimizationTile } from '../../../state-management/models/report-dashboard.model';
import { DashboardContext } from '../../../../../admin/contexts/dashboard.context';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ziro-dashboard-license-optimizer-tile',
  templateUrl: './dashboard-license-optimizer-tile.component.html',
  standalone: false,
})
export class DashboardLicenseOptimizerTileComponent implements OnInit {
  private _dashboardContext = inject(DashboardContext);

  optimizationTileData$: Observable<OptimizationTile> = this._dashboardContext.state$.pipe(
    map((state) => state.optimizationTile),
  );

  ngOnInit(): void {
    this._dashboardContext.loadOptimizationTile();
  }
}
